import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

// 新增综合信息管理
export function addInformationInfo(data) {
  return request({
    url: '/bus/information/add',
    method: 'POST',
    data
  })
}

// 查询综合信息管理信息
export function getInformationInfos(param) {
  const url = handlerGetUrlParams('/bus/information/list', param)
  return request({
    url,
    method: 'GET'
  })
}

export function checkInformationInfos(id) {
  return request({
    url: `/bus/information/${id}`,
    method: 'GET'
  })
}

// 编辑综合信息管理
export function editInformationInfos(data) {
  return request({
    url: '/bus/information',
    method: 'PUT',
    data
  })
}

// 删除综合信息管理
export function deleteInformationInfos(ids) {
  return request({
    url: `/bus/information/${ids}`,
    method: 'DELETE'
  })
}

// 发布综合信息管理
export function issueInformationInfos(ids) {
  return request({
    url: `/bus/information/publish`,
    method: 'PUT',
    data: ids
  })
}

// 下架综合信息管理
export function dropInformationInfos(ids) {
  return request({
    url: `/bus/information/drop`,
    method: 'PUT',
    data: ids
  })
}